export const MESSAGE_CONSTANTS =
{
  'usernotexist': 'That user is not in our records. Please try again.',
  'userexist': 'Email is already in use. If you are already a member please <a href="/login">login here</a>.',
  'wrongpassword': 'Wrong Password.',
  'nousertype': 'No User Type.',
  'emailsent': 'Your request was sent successfully!',
  'veteran_register': 'Veteran Register successfully. Please Login.',
  'college_register': 'Successfully Registered.',
  'email_error': 'Unable to sent Email.',
  'database_error': 'Unable to process data.',
  'error_message': 'Unable to Register.',
  'password_length': 'Password length should be greater than 6 characters.'
}

export const PHONE_REQUIRED_FOR_REQUEST_INFO_MESSAGE = "One or more of the schools you selected require a phone number to respond to your inquiry. Please provide your phone number."
export const REQUEST_INFO_RESEND_MESSAGE = "You previously sent a message to [college_name]. Would you like to send another message?"